import React from "react"
import { Button } from "reactstrap"
import PoweredByQuoli from "../PoweredByQuoli"
import { useSearchParams } from "react-router-dom"
import RcfHeader from "./RcfHeader"
import { getImageUrl } from "../../../helper"

export default function NewReviewSubSimple(props) {
  let { settings, setOrderProductIndex, brandSettingsData } = props
  const [searchParams, setSearchParams] = useSearchParams()
  const isOnSite = searchParams.get("isOnsite") === "true"
  const merchantId = searchParams.get("merchantId")
  return (
    <div
      className="review-simple-container review-rcf-sub"
    // onLoad={() => {
    //   setTimeout(() => {
    //     window.parent.postMessage({ showRcf: true }, "*")
    //     window.location.reload()
    //   }, 3000)
    // }}
    >


      <div className="review-sub-simple-popup ">

        <div className="popup-content my-submit-popup">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
            }}
          >


            <h3 className="highlight review-text-heading">
              {settings?.headingSubmission?.text ??
                "Review Submitted!"}
            </h3>
            <p className="review-simple-highlight review-text-submit">
              {settings?.descriptionSubmission?.text ??
                "Thank you for Submitting your feedback."}
            </p>
          </div>
          <div className="submit-btn-rcf-main-div-cont align-items-center">
            {isOnSite === true || isOnSite === null ? (
              <Button
                className="rcf-submit-btn-sub rcf-close-btn"
                onClick={() => {
                  window.parent.postMessage({ showRcf: true }, "*")
                }}
              >
                Close
              </Button>
            ) : isOnSite === false ? (
              <a
                className="rcf-submit-btn-sub redirect-btn"
                style={{
                  all: "unset",
                  cursor: "pointer",
                  color: "white",
                }}
                href={`https://${merchantId}`}
                target="_blank"
              >
                Visit Store
              </a>
            ) : (
              <Button
                className="rcf-submit-btn-sub rcf-close-btn"
                onClick={() => {
                  window.parent.postMessage({ showRcf: true }, "*")
                }}
              >
                Close
              </Button>
            )}
          </div>
          <div className="text-center w-100">{/* <PoweredByQuoli /> */}</div>
          {/* <div className="last-submit-heading-main-container">
            <span className="rcf-company-heading-powered">Powered by</span>
            <div className="quoli-logo-main-div">
              <img src={QuoliLogo} alt="QuoliLogo" />
              <span className="quoli-title-text-tag">Quoli</span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}
